import React, { useState } from 'react';
import { Button, Input, Label } from 'reactstrap';

// Recovery code hanya ditampilkan sekali (setelah MFA aktif). User wajib menyimpannya
// sebelum lanjut: dipakai bila HP / aplikasi authenticator hilang.
const RecoveryCodesPanel = ({ codes, email, continueLabel, onContinue }) => {
  const [saved, setSaved] = useState(false);
  const [copied, setCopied] = useState(false);
  const text = codes.join('\n');

  const copyCodes = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  const downloadCodes = () => {
    const header = `HYROC recovery codes${email ? ` for ${email}` : ''}\nEach code can be used once.\n\n`;
    const blob = new Blob([header + text + '\n'], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'hyroc-recovery-codes.txt';
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className='mfa-recovery'>
      <div className='mfa-recovery__notice mb-3'>
        <i className='ri-key-2-line' aria-hidden='true' />
        <span>
          Save these recovery codes in a safe place. If you lose access to your
          authenticator app, you can sign in with one of these codes. Each code
          can be used once, and they will not be shown again.
        </span>
      </div>

      <ul className='mfa-recovery__codes mb-3' aria-label='Recovery codes'>
        {codes.map(code => (
          <li key={code}>
            <code>{code}</code>
          </li>
        ))}
      </ul>

      <div className='d-flex gap-2 mb-3'>
        <Button
          type='button'
          color='light'
          size='sm'
          onClick={copyCodes}
          className='d-flex align-items-center'
        >
          <i
            className={`${copied ? 'ri-check-line' : 'ri-file-copy-line'} me-2`}
            aria-hidden='true'
          />
          {copied ? 'Copied' : 'Copy'}
        </Button>
        <Button
          type='button'
          color='light'
          size='sm'
          onClick={downloadCodes}
          className='d-flex align-items-center'
        >
          <i className='ri-download-2-line me-2' aria-hidden='true' />
          Download
        </Button>
      </div>

      <div className='form-check mb-3'>
        <Input
          className='form-check-input'
          type='checkbox'
          id='recovery-saved-check'
          checked={saved}
          onChange={e => setSaved(e.target.checked)}
        />
        <Label
          className='form-check-label login-check-label'
          htmlFor='recovery-saved-check'
        >
          I have saved my recovery codes
        </Label>
      </div>

      <Button
        type='button'
        disabled={!saved}
        onClick={onContinue}
        className='btn login-btn-primary w-100 d-flex align-items-center justify-content-center'
      >
        {continueLabel}
      </Button>
    </div>
  );
};

export default RecoveryCodesPanel;
